<template>
    <transition appear :enter-active-class="'animated' + (props.isLeft ? ' flipInX' : ' flipInX')"
        :leave-active-class="'animated' + (props.isLeft ? ' flipOutX' : ' flipOutX')">
        <div v-if="selfVisible" :class="props.isLeft ? 'btn_left' : 'btn'"
            :style="(bgColor ? ('background-color:' + bgColor + ';') : '') + (textColor ? ('color:' + textColor) + ';' : '') + (bottom ? ('bottom:' + bottom) + ';' : '')">
            <q-icon v-if="selfIcon && !iconRight" :name="selfIcon ? selfIcon : 'arrow_back_ios'" size="30px"
                style="margin-left: -20px; margin-right: 10px;" />
            <div>{{ selfMsg }}</div>
            <q-icon v-if="selfIcon && iconRight" :name="selfIcon ? selfIcon : 'arrow_forward_ios'" size="30px"
                style="margin-left: -20px; margin-right: 10px;" />
        </div>
    </transition>
</template>

<script setup>
import { onMounted, onUnmounted, ref, defineEmits, watch } from 'vue';

const selfVisible = ref(false);
const selfMsg = ref('');
const selfIcon = ref(null);
let msgCnt = 0;

const emit = defineEmits(['resetMsg']);

const props = defineProps({
    'visible': {
        default: false
    },
    'isLeft': {
        default: false
    },
    'iconRight': {
        default: false
    },
    'text': {
        default: ''
    },
    'bgColor': {
        default: null
    },
    'textColor': {
        default: null
    },
    'bottom': {
        default: null
    },
    'icon': {
        default: null
    },
});

onMounted(() => {
    // console.log();
    if (props.text !== '') {
        selfVisible.value = props.visible;
        selfMsg.value = props.text;
        selfIcon.value = props.icon;
        msgCnt += 1;
        setTimeout(() => {
            emit('resetMsg', true);
            msgCnt -= 1
            if (msgCnt === 0) {
                selfVisible.value = false;
            }
            selfIcon.value = null;

        }, 3000)
    }
})

onUnmounted(() => {
    // root.dispose();
});

watch(() => props.text, (newValue) => {
    if (newValue !== '') {
        selfMsg.value = newValue;
        selfIcon.value = props.icon;
        emit('resetMsg', true);
        if (selfVisible.value) {
            selfVisible.value = false;
            msgCnt += 1;
            setTimeout(() => {
                selfVisible.value = true;
                setTimeout(() => {
                    msgCnt -= 1;
                    if (msgCnt === 0) {
                        selfVisible.value = false;
                    }
                    selfIcon.value = null;
                }, 3000)
            }, 500)
        } else {
            msgCnt += 1;
            // selfMsg.value = newValue;
            selfVisible.value = true;
            emit('resetMsg', true);
            setTimeout(() => {
                msgCnt -= 1;
                if (msgCnt === 0) {
                    selfVisible.value = false;
                }
                selfIcon.value = null;
            }, 3000)
        }
    }
});


</script>

<style scoped lang="scss">
.btn {
    border-radius: 40px;
    background-color: #222222;
    // font-size: 2vmin;
    // padding: 2.75vmin 3.33vmin;
    display: inline-flex;
    align-items: center;
    color: white;
    position: fixed;
    // bottom: calc(20vh + 10.33vmin);
    bottom: calc(20vh + 55px);
    z-index: 999999999999;
    right: 10px;
    margin: 10px;
    // font-size: 14px;
    // padding: 12px 32px;

    padding: 1.33vmin 3vmin;
    margin-right: 3.33vmin;
    font-size: 1.3vw;
    font-weight: 500;
    line-height: 2.1vw;
    opacity: 0.8;
}

.btn_left {
    border-radius: 40px;
    background-color: #222222;
    margin: 10px;
    display: inline-flex;
    align-items: center;
    color: gray;
    position: fixed;
    // bottom: calc(20vh + 10.33vmin);
    bottom: calc(20vh + 55px);
    left: 10px;
    z-index: 999999999999;
    // font-size: 14px;
    // padding: 12px 32px;

    padding: 1.33vmin 3vmin;
    margin-right: 3.33vmin;
    font-size: 1.3vw;
    font-weight: 500;
    line-height: 2.1vw;
    opacity: 0.8;
}
</style>
